import { get } from 'services/api';

import { decreaseLoading, increaseLoading } from './loading';

const receiveShows = (shows: Array<Object>) => ({
  type: 'RECEIVE_SHOWS',
  shows,
});

const receiveShowsError = (error: any) => ({
  type: 'RECEIVE_SHOWS_ERROR',
  error,
});

export const fetchShows = () => (dispatch: Function) => {
  dispatch({
    type: 'FETCH_SHOWS',
  });

  dispatch(increaseLoading());

  return get({
    url: `https://mobile-api.devzz.ninja/app/podcasts`,
  })
    .then(
      (res) => {
        dispatch(receiveShows(res.data.data));
        dispatch(decreaseLoading());
      },
      (err) => {
        dispatch(decreaseLoading());
        dispatch(receiveShowsError(err));
      }
    )
    .catch((err: any) => dispatch(receiveShowsError(err)));
};
